import { Validators } from "@angular/forms"
import { ITableKey } from "src/app/modules/shared/components/basic-table/basic-table.constants"
import { IFormKey } from "src/app/modules/shared/models/forms"

export const life_change_investment_line_form_template = {
    line: ''
}

export const life_change_investment_line_form_validators = {
    line: [Validators.required]
}

export const life_change_investment_line_form_keys: IFormKey[] = [
    {
        id: 'line-field',
        label: 'Nuova linea investimento',
        controlName: 'line',
        css: 'col-8',
        type: 'SELECT',
        options: []
    }
]

export const LIFE_CHANGE_INVESTMENT_LINE_ASSETS_TABLE_TABLE_KEYS: ITableKey[] = [
    {
        key: 'description',
        label: 'Nome fondo'
    },
    {
        key: 'fundAmount',
        label: 'Importo Attuale'
    },
        {
        key: 'futureFundAmount',
        label: 'Importo Futuro'
    },
    {
        key: 'differenceAmount',
        label: 'Scostamento Importo'
    }
]

export interface IChangeLineInvestmentRequest {
    policyNumber: string;
    selectedLine: {
        code: string;
        funds: {
            code: string;
            description: string;
            fundAmount: number;
            percentage: number;
        }[];
    };
    ndgTutoreODelegato?: string;
    codiceLineaCompagnia?: string[];
    controvaloreLineaCompagnia?: string[];
    consultancyAmount?: string;
}